export enum MenuItemName {
  General = 'General',
  Accessibility = 'Accessibility',
  Availability = 'Availability & Prices',
  Copywriting = 'Copywriting',
  Medias = 'Medias',
}
